import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Quote, TopInstrument } from '@zero/shared/util-models';
import { environment } from 'environments/environment';
import { catchError, Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class HomeInfrastructure {
  readonly #endpoint = `${environment.apihost}/api/quote`;

  readonly #http = inject(HttpClient);

  public getQuotes(isins: string[]): Observable<Quote[]> {
    return this.#http.get<Quote[]>(`${this.#endpoint}?isins=${isins.join()}`).pipe(catchError(() => of([])));
  }

  public getPrevQuotes(isins: string[]): Observable<Quote[]> {
    return this.#http.get<Quote[]>(`${this.#endpoint}/prev?isins=${isins.join()}`).pipe(catchError(() => of([])));
  }

  public getTopInstruments(): Observable<TopInstrument[]> {
    return this.#http.get<TopInstrument[]>(`${environment.apihost + environment.stats}/orders/top/7`);
  }
}
